import { z } from 'zod';
/**
 * Projects-owned duplicate of the Assistant legacy Project-resolution seam
 * (consumer-contract duplication pattern — no cross-package import in either
 * direction). The slot string and payload shapes must stay identical to
 * `assistant-legacy-update-orchestration.contract.ts`; the executable
 * apps/api compatibility test enforces that.
 */
export const projectsLegacyResolutionCapability = 'projects.legacy-project-resolution.v1';
export const projectsLegacyResolutionProviderId = projectsLegacyResolutionCapability;
export const projectsLegacyResolutionSlot = 'assistant.legacy-project-resolution';
/** The Assistant-owned request version this provider accepts (duplicated). */
export const projectsLegacyResolutionRequestVersion = 'assistant.legacy-project-resolution.v1';
export const projectsLegacyResolutionRequestSchema = z.strictObject({
    contractVersion: z.literal(projectsLegacyResolutionRequestVersion),
    requestId: z.string().uuid(),
    sourceReference: z.string().min(1).max(160),
});
/**
 * Exact resolution only: a well-formed UUID resolves by id; anything else
 * resolves by exact Project number. `(tenant_id, project_number)` is unique,
 * so an exact reference can never match two Projects; `ambiguous` stays in
 * the contract for shape parity with the Assistant-side consumer schema. RLS
 * keeps unreadable Projects invisible, so they resolve as `not-found`.
 */
export const projectsLegacyResolutionResultSchema = z.discriminatedUnion('status', [
    z.strictObject({
        status: z.literal('resolved'),
        tenantId: z.string().uuid(),
        projectId: z.string().uuid(),
        projectNumber: z.string().min(1).max(80),
        revision: z.number().int().positive(),
        name: z.string().min(1).max(240),
        projectStatus: z.string().min(1).max(80),
        projectType: z.string().min(1).max(80),
        priority: z.enum(['low', 'normal', 'high', 'emergency']),
        propertyType: z.string().min(1).max(80).nullable(),
        isWaterJob: z.boolean(),
        startDate: z.string().date().nullable(),
        targetCompletionDate: z.string().date().nullable(),
        addressLine1: z.string().max(240).nullable(),
        city: z.string().max(120).nullable(),
        region: z.string().max(120).nullable(),
        postalCode: z.string().max(40).nullable(),
    }),
    z.strictObject({ status: z.literal('not-found') }),
    z.strictObject({ status: z.literal('ambiguous'), matchCount: z.number().int().min(2) }),
]);
//# sourceMappingURL=projects-legacy-resolution.contract.js.map